import React, { Component } from "react";
import "./OurServices.css";
import { Fade } from "react-awesome-reveal";
import { ThemeProps } from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type Props = {
	theme: ThemeProps,
}
export default function OurServices({ theme }: Props) {
	const { t, i18n } = useTranslation();
	return (
		<div className="main ourservices" id="certs">
			<div className="row justify-content-center">
				
				<h2 className="ourservices_h2" style={{textAlign: "center"}}>{t("service.title")}</h2>
				<p className="ourservice_p" style={{textAlign: "center"}}>
					{t("service.subtitle")}
				</p>


			</div>
			<div className="row justify-content-center">
				<div className="col-lg-6 mb-5">
					<Fade direction="left" duration={1000} triggerOnce={true}>
					<div className="textcard-item text-center">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="mdi:company"
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3>{t("service.company")}</h3>
						</div>
						<div className="textcard-text">
							<p>{t("service.company.desc")}</p>
						</div>
						<div className="textcard-more">
							<a href="/vorteile#c12" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
						</div>
					</div>
					</Fade>
				</div>

				<div className="col-lg-6 mb-5">
					<Fade direction="right" duration={1000} triggerOnce={true}>
					<div className="textcard-item text-center">
						<div className="textcard-icon">
							<span
								className="iconify"
								data-icon="material-symbols:person"
								style={{ color: "var(--primary)", fontSize: "45px" }}
								data-inline="false"
							></span>
						</div>
						<div className="textcard-headline ">
							<h3>{t("service.consultant")}</h3>
						</div>
						<div className="textcard-text">
							<p>
								{t("service.consultant.desc")}
							</p>
						</div>
						<div className="textcard-more">
							<a href="/vorteile#c13" title="Mehr erfahren" className="link-dpaii">{t("link.more")}</a>
						</div>
					</div>
					</Fade>
				</div>
			</div>

		</div>
	);
}
